import Vue from 'vue';

import NuxtLinkExt from '~/citi-baseline/components/NuxtLinkExt.vue';
import TransitionExt from '~/citi-baseline/components/TransitionExt.vue';

const components = { NuxtLinkExt, TransitionExt };
Object.entries(components).forEach(([name, component]) => {
	Vue.component(name, component);
});
